import * as types from '../mutations'

const services = {
  paymentOption: window.abp.services.app.paymentOption
}

// initial state
const state = {
  all: [],
  repeatsTypes: [],
  pagination: {},
  activePaymentOption: {}
}

// getters
const getters = {
  allPaymentOptions: state => state.all,
  allPaymentOptionsPagination: state => state.pagination,
  activePaymentOption: state => state.activePaymentOption,
  allRepeatsTypes: state => state.repeatsTypes
}

// actions
const actions = {
  getPaymentOptions({ commit }, request) {
    if (!request) {
      request = {}
    }
    return new Promise((resolve, reject) => {
      services.paymentOption.getList(request).done(function (response) {
        let paymentOptions = response.items
        let pagination = {
          currentPage: response.currentPage,
          totalCount: response.totalCount,
          totalPage: response.totalPage
        }
        commit(types.DATA.RECEIVE_PAYMENT_OPTIONS, { paymentOptions, pagination })
        resolve()
      })
    })
  },
  getPaymentOption({ commit }, id) {
    let request = { id: id }
    return new Promise((resolve, reject) => {
      if (!request.id) {
        commit(types.DATA.UPDATE_ACTIVE_PAYMENT_OPTION, {})
        resolve()
      } else {
        services.paymentOption.get(request).done(function (response) {
          commit(types.DATA.UPDATE_ACTIVE_PAYMENT_OPTION, response)
          resolve()
        })
      }
    })
  },
  createOrUpdatePaymentOption({ commit }, paymentOption) {
    return new Promise((resolve, reject) => {
      let action = paymentOption.id !== '' ? services.paymentOption.update(paymentOption) : services.paymentOption.create(paymentOption)
      action
        .done(function (response) {
          commit(types.DATA.REMOVE_VALIDATION_ERRORS)
          commit(types.DATA.UPDATE_ACTIVE_PAYMENT_OPTION, response)
          resolve()
        })
        .fail(function (response) {
          commit(types.DATA.SET_VALIDATION_ERRORS, response)
          reject()
        })
    })
  },
  deletePaymentOption({ commit }, id) {
    return new Promise((resolve, reject) => {
      services.paymentOption.delete({ id: id })
        .done(function (response) {
          commit(types.DATA.REMOVE_VALIDATION_ERRORS)
          commit(types.DATA.UPDATE_ACTIVE_PAYMENT_OPTION, {})
          resolve()
        })
    })
  },
  getRepeatsTypes({ commit }) {
    return new Promise((resolve, reject) => {
      services.paymentOption.getRepeatsTypes().done(function (response) {
        commit(types.DATA.RECEIVE_REPEATS_TYPE, response)
        resolve()
      })
    })
  }
}

// mutations
const mutations = {
  [types.DATA.RECEIVE_PAYMENT_OPTIONS](state, { paymentOptions, pagination }) {
    state.all = paymentOptions
    state.pagination = pagination
  },
  [types.DATA.RECEIVE_REPEATS_TYPE](state, repeatsTypes) {
    state.repeatsTypes = repeatsTypes
  },
  [types.DATA.UPDATE_ACTIVE_PAYMENT_OPTION](state, paymentOption) {
    state.activePaymentOption = paymentOption
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./scripts/store/modules/payment-options.js